import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./RightSideBar.css";

const RightSideBar = () => {
  const [name, setName] = useState("");
  const [make, setMake] = useState("");
  const [record_ID, setRecordID] = useState("");
  const [priceMin, setPriceMin] = useState("");
  const [priceMax, setPriceMax] = useState("");
  const [shape, setShape] = useState("");

  const [makeOptions, setMakeOptions] = useState([]);
  const [shapeOptions, setShapeOptions] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchFilterCounts = async () => {
      try {
        const res = await axios.get(
          "https://automotive-backend-production.up.railway.app/inventory/filters"
        );
        setMakeOptions(res.data.makes);
        setShapeOptions(res.data.shapes);
      } catch (err) {
        console.error("Failed to load filter options", err);
      }
    };

    fetchFilterCounts();
  }, []);

  const handleSearch = () => {
    // Validate Record ID (allow alphanumeric + hyphens)
    if (record_ID && !/^[a-zA-Z0-9-]+$/.test(record_ID)) {
      alert("Record ID should be alphanumeric (letters, numbers, hyphens).");
      return;
    }

    // Validate Vehicle Name (letters + spaces only)
    if (name && !/^[a-zA-Z\s]+$/.test(name)) {
      alert("Vehicle name should only contain letters and spaces.");
      return;
    }

    // Validate prices (numbers only)
    if ((priceMin && isNaN(priceMin)) || (priceMax && isNaN(priceMax))) {
      alert("Price values must be numeric.");
      return;
    }

    // Validate price range (both fields required)
    if ((priceMin && !priceMax) || (!priceMin && priceMax)) {
      alert("Please provide both Minimum and Maximum Price.");
      return;
    }

    // Validate price range min <= max
    if (
      priceMin &&
      priceMax &&
      Number(priceMin) > Number(priceMax)
    ) {
      alert("Minimum price cannot be greater than Maximum price.");
      return;
    }

    const params = new URLSearchParams();

    if (name) params.append("Name", name);
    if (make) params.append("Make", make);
    if (shape) params.append("Category", shape);
    if (record_ID) params.append("RecordNumber", record_ID);

    if (priceMin && priceMax) {
      params.append("Price", `${priceMin}-${priceMax}`);
    }

    navigate(`/search?${params.toString()}`);
  };

  return (
    <div className="right-sidebar">
      <div className="search-container">
        <h2>Search Vehicles</h2>
        <div className="search-fields">
          <input
            type="text"
            placeholder="Record ID"
            className="search-input"
            value={record_ID}
            onChange={(e) => setRecordID(e.target.value)}
          />

          <input
            type="text"
            placeholder="Vehicle Name"
            className="search-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />

          <select
            className="search-input"
            value={make}
            onChange={(e) => setMake(e.target.value)}
          >
            <option value="">Make (ALL)</option>
            {makeOptions.map((item, index) => (
              <option key={index} value={item._id}>
                {item._id} ({item.count})
              </option>
            ))}
          </select>

          <div className="price-range">
            <input
              type="text"
              placeholder="Price (Min)"
              className="search-input"
              value={priceMin}
              onChange={(e) => setPriceMin(e.target.value)}
            />
            <input
              type="text"
              placeholder="Price (Max)"
              className="search-input"
              value={priceMax}
              onChange={(e) => setPriceMax(e.target.value)}
            />
          </div>

          <select
            className="search-input"
            value={shape}
            onChange={(e) => setShape(e.target.value)}
          >
            <option value="">Shape (ALL)</option>
            {shapeOptions.map((item, index) => (
              <option key={index} value={item._id}>
                {item._id} ({item.count})
              </option>
            ))}
          </select>

          <button className="search-button" onClick={handleSearch}>
            Search
          </button>
        </div>
      </div>
    </div>
  );
};

export default RightSideBar;
